// IL REGISTRO DELLE BARRE FISSE (2026-09-13).
//
// In cima al vault possono esserci quattro cose contemporaneamente: la
// striscia dell'offerta, il pannello Trasferimenti, l'avviso dello spazio, e
// sotto di loro l'intestazione del vault. Ognuna e' `position: fixed`, quindi
// nessuna sa dell'altra: senza un accordo si coprono a vicenda.
//
// L'accordo e' questo registro. Ogni barra dice quanto e' alta; qui si
// calcola, in ordine, DOVE comincia ognuna e QUANTO scende la pagina in
// totale. Due numeri scritti come variabili CSS, che il foglio di stile usa
// senza sapere chi c'e' e chi non c'e'.
//
// PERCHE' UN REGISTRO E NON UNA SOMMA A MANO. Fino a stamattina il conto era
// scritto nel CSS: `calc(var(--cc-altezza) + var(--bs-alto))`. Ha funzionato
// finche' le barre erano due, e si e' rotto appena ne e' comparsa una terza —
// la striscia dell'offerta, che aveva un conteggio suo da prima e nessuno
// l'ha aggiunta alla somma. Con il registro, una barra nuova si aggiunge
// all'ORDINE qui sotto e tutto il resto si sistema da solo.

// Dall'alto verso il basso. Chi sta prima in questa lista sta piu' in alto.
const ORDINE = ['offerta', 'trasferimenti', 'avviso'];

// LA SECONDA PILA: quella APPICCICOSA, dentro il vault (2026-09-13).
//
// Sotto le barre fisse ce n'e' un'altra, fatta di pezzi `position: sticky`
// che restano visibili mentre l'elenco scorre: l'intestazione del vault, la
// pastiglia dello spazio, la riga dei filtri (Ordina / Nome / Data /
// Dimensione) e la riga dei titoli della tabella.
//
// Il difetto che risolve: ognuno aveva il suo `top` scritto a mano —
// l'intestazione a var(--barre-fisse), la pastiglia a var(--vz-header-h) e
// basta, i filtri a niente. Il risultato era che scorrendo l'intestazione
// bianca si fermava SOPRA la riga dei filtri e la tagliava a meta': tre
// numeri scollegati che dovevano sommarsi e non si sommavano.
//
// Qui si sommano da soli, e la pila comincia dove finiscono le barre fisse:
// se compare l'avviso dello spazio, tutta la pila scende insieme.
const ORDINE_APPICCICATO = ['testa', 'pastiglia', 'ordina', 'tabella'];

const altezze = new Map();
const altezzeAppiccicate = new Map();
let sommaFisse = 0;

function applicaAppiccicate() {
  const radice = document.documentElement;
  let somma = sommaFisse;
  for (const id of ORDINE_APPICCICATO) {
    radice.style.setProperty(`--sticky-top-${id}`, `${somma}px`);
    somma += altezzeAppiccicate.get(id) || 0;
  }
}

function applica() {
  if (typeof document === 'undefined') return;
  const radice = document.documentElement;
  let somma = 0;
  for (const id of ORDINE) {
    // Dove comincia questa barra: sotto tutte quelle che la precedono.
    radice.style.setProperty(`--barra-top-${id}`, `${somma}px`);
    somma += altezze.get(id) || 0;
  }
  // Di quanto deve scendere la pagina per non finire sotto nessuna.
  radice.style.setProperty('--barre-fisse', `${somma}px`);
  sommaFisse = somma;
  // La pila appiccicata comincia da qui: se le barre fisse cambiano, scende.
  applicaAppiccicate();
}

/** La barra `id` e' alta `px`. Da chiamare a ogni cambio di altezza. */
export function registraBarra(id, px) {
  if (altezze.get(id) === px) return;
  altezze.set(id, px);
  applica();
}

/** La barra `id` non c'e' piu'. */
export function togliBarra(id) {
  if (!altezze.has(id)) return;
  altezze.delete(id);
  applica();
}

/**
 * Da usare dentro un useEffect: misura l'elemento dal vivo e lo tiene
 * registrato finche' resta montato. L'altezza cambia con la lingua, col
 * numero di righe e quando si va a capo su schermo stretto, quindi si misura
 * con un ResizeObserver invece di fidarsi di un numero scritto nel CSS.
 */
export function seguiBarra(id, elemento) {
  if (!elemento) { togliBarra(id); return () => {}; }
  const misura = () => registraBarra(id, elemento.offsetHeight);
  misura();
  const oss = new ResizeObserver(misura);
  oss.observe(elemento);
  return () => { oss.disconnect(); togliBarra(id); };
}

/** Come registraBarra, ma per la pila appiccicata dentro il vault. */
export function registraAppiccicata(id, px) {
  if (altezzeAppiccicate.get(id) === px) return;
  altezzeAppiccicate.set(id, px);
  applicaAppiccicate();
}

export function togliAppiccicata(id) {
  if (!altezzeAppiccicate.has(id)) return;
  altezzeAppiccicate.delete(id);
  applicaAppiccicate();
}

/** Come seguiBarra, ma per la pila appiccicata. */
export function seguiAppiccicata(id, elemento) {
  if (!elemento) { togliAppiccicata(id); return () => {}; }
  const misura = () => registraAppiccicata(id, elemento.offsetHeight);
  misura();
  const oss = new ResizeObserver(misura);
  oss.observe(elemento);
  return () => { oss.disconnect(); togliAppiccicata(id); };
}
